import connect from '@clearscore/redux.connect';
import { selectors as marketSelectors } from '@clearscore/redux.market';
import { selectors as routerSelectors } from '@clearscore/redux.router';
import { selectors as loginSelectors } from '@clearscore/redux.session';
import formStatus from '@clearscore/helpers.form-status';
import { selectors as alertSelectors } from '@clearscore/redux.alerts';

import Component from './component';
import lang from './lang';

const getEmailValue = (state, locationState, isAlreadyRegisteredPath) => {
    if (isAlreadyRegisteredPath) {
        return routerSelectors.getQueryParams(state).email;
    }

    if (locationState.isAlreadyRegistered) {
        return locationState.registeredEmailValue;
    }

    return '';
};

const mapState = (state) => {
    const language = marketSelectors.getLegacyLanguage(state)(lang);
    const locationState = routerSelectors.getLocationState(state);
    const isAlreadyRegisteredPath = routerSelectors.getCurrentPath(state).includes('/already-registered');
    const loginFormStatus = formStatus(loginSelectors.getPredicate(state).fetch);

    return {
        language,
        locationState,
        isAlreadyRegisteredPath,
        isLoading: loginFormStatus.submitting || loginFormStatus.submitSucceeded,
        isAlertOpen: Boolean(alertSelectors.getAlert(state).isAlertOpen),
        initialValues: {
            email: getEmailValue(state, locationState, isAlreadyRegisteredPath),
        },
    };
};

export default connect(mapState)(Component);
